//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"InstanceName",1,1],[0,"SelectedConfigurationName",1,0],[0,"SelectedConfigurationPart",1,"Part",0]],[[["numInstance","instanceNames"],"GetInstanceNames",{},0,1],[["numInstances","ownerParts"],"GetInstanceNamesEx",{R_:{names:""}},0,0],[["ownerParts","names"],"SetInstanceNamesEx",{},2,0],[["tagInfos"],"SetTags",{},1,1],[["numTags"],"GetTags",{R_:{tagInfos:""}},0,1],[["tagInfos"],"SetTagsEx",{},1,1],[["numTags"],"GetTagsEx",{R_:{tagInfos:""}},0,1],[["instanceName","ownerPart","numTags","tagInfos","type","bInitial"],"GetInstanceInformation",{},2,0],[["instanceName","ownerPart","tagInfos","type","bInitial"],"SetInstanceInformation",{},5,0]],[]];
SPLM.Mechatronics.ProfinetClientBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ProfinetClientBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ProfinetClientBuilder.TagInfo = class{
    constructor(strName,eDataType,eIOType,address,bDint){
        this.strName=strName;this.eDataType=eDataType;this.eIOType=eIOType;this.address=address;this.bDint=bDint;}
    get Strname(){return this.strName}
    set Strname(val){this.strName = val}
    get Edatatype(){return this.eDataType}
    set Edatatype(val){this.eDataType = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Address(){return this.address}
    set Address(val){this.address = val}
    get Bdint(){return this.bDint}
    set Bdint(val){this.bDint = val}
};

SPLM.Mechatronics.ProfinetClientBuilder.TagInfoEx = class{
    constructor(strName,strDataType,eIOType,address){
        this.strName=strName;this.strDataType=strDataType;this.eIOType=eIOType;this.address=address;}
    get Strname(){return this.strName}
    set Strname(val){this.strName = val}
    get Strdatatype(){return this.strDataType}
    set Strdatatype(val){this.strDataType = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Address(){return this.address}
    set Address(val){this.address = val}
};

SPLM.Mechatronics.ProfinetClientBuilder.Types = Object.freeze({
    "Invalid" : "Invalid", "PcstationBased" : "PcstationBased", "PndriverBased" : "PndriverBased"});

export default SPLM;